<table class="table table-hover table-responsive-md ecommerce-account-table transactions-table">
    @if (sortDropdownOptions.length > 0) {
        <caption class="sort-field-md">
            <p-select [options]="sortDropdownOptions"
                      [ngModel]="activeSortField"
                      (onChange)="onSortFieldChange($event.value)"
                      class="sort-field"
                      optionLabel="name"
                      optionValue="id"
                      placeholder=" Sort by:"></p-select>
            <button type="button"
                    class="sort-direction-btn"
                    (click)="onSortDirectionToggle()"
                    aria-label="Toggle sort direction">
                <em [class]="sortClass(activeSortField ?? '')" aria-hidden="true"></em>
            </button>
        </caption>
    }
    <thead>
    <tr>
        <th scope="col" [attr.aria-sort]="ariaSort('dateTimeCreated')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('dateTimeCreated')"
                    (click)="onSort('dateTimeCreated')">
                Date Created <em [class]="sortClass('dateTimeCreated')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col" [attr.aria-sort]="ariaSort('accountNumber')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('accountNumber')"
                    (click)="onSort('accountNumber')">
                Account Number <em [class]="sortClass('accountNumber')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col" [attr.aria-sort]="ariaSort('referenceNumber')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('referenceNumber')"
                    (click)="onSort('referenceNumber')">
                Reference <em [class]="sortClass('referenceNumber')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col" [attr.aria-sort]="ariaSort('customer')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('customer')"
                    (click)="onSort('customer')">
                Name <em [class]="sortClass('customer')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col">Store</th>
        <th scope="col" [attr.aria-sort]="ariaSort('amount')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('amount')"
                    (click)="onSort('amount')">
                Amount <em [class]="sortClass('amount')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col" [attr.aria-sort]="ariaSort('dateTimePaid')">
            <button type="button"
                    class="sortable-header-btn"
                    [disabled]="!isColumnSortable('dateTimePaid')"
                    (click)="onSort('dateTimePaid')">
                Date Paid <em [class]="sortClass('dateTimePaid')" aria-hidden="true"></em>
            </button>
        </th>
        <th scope="col">Order</th>
        <th scope="col">Status</th>
        <th scope="col"></th>
    </tr>
    </thead>
    <tbody class="table-hover text-nowrap">
        @if (loading) {
            <tr>
                <td class="text-center" colspan="10">{{ loadingText }}</td>
            </tr>
        } @else if (error) {
            <tr>
                <td class="text-center data-unavailable" colspan="10">{{ errorText }}</td>
            </tr>
        } @else {
            @for (account of displayedRows; track trackRowKey(account.id, $index)) {
                <tr (click)="onRowClick(account)" [class.cursor-pointer]="clickable" class="active-color">
                    <td>
                        <span class="p-column-title">Date Created</span>
                        {{ account?.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                    </td>
                    <td>
                        <span class="p-column-title">Account Number</span>
                        {{ account?.accountNumber }}
                    </td>
                    <td>
                        <span class="p-column-title">Reference</span>
                        {{ account?.referenceNumber }}
                    </td>
                    <td>
                        <span class="p-column-title">Name</span>
                        {{ account?.customer }}
                    </td>
                    <td>
                        <span class="p-column-title">Store</span>
                        {{ getStoreLabel(account) }}
                    </td>
                    <td>
                        <span class="p-column-title">Amount</span>
                        {{ getAmount(account) | toMajor | currency:'R ' }}
                    </td>
                    <td>
                        <span class="p-column-title">Date Paid</span>
                        {{ account?.dateTimePaid ? (account?.dateTimePaid | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss') : '-' }}
                    </td>
                    <td>
                        <span class="p-column-title">Order</span>
                        {{ getOrderNumber(account) }}
                    </td>
                    <td>
                        <span class="p-column-title">Status</span>
                        <span [ngClass]="getLatestStatusClass(account)">
                            {{ getLatestStatusLabel(account) }}
                        </span>
                    </td>
                    <td class="actions-cell">
                        <div #menu class="text-center">
                            <div [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot download invoices.' : null">
                                <button type="button"
                                        (click)="openMenu($event, contextMenu, account)"
                                        [class.grey-circle-style]="isGuestAdminUser()"
                                        [attr.aria-label]="'Open actions for account ' + (account?.accountNumber ?? '')"
                                        class="circle-style">
                                    <i class="fa fa-solid fa-ellipsis-vertical fa-lg"></i>
                                </button>
                            </div>
                        </div>
                        <p-contextMenu #contextMenu
                                       [appendTo]="'body'"
                                       [model]="activeMenuItems"
                                       [target]="menu"
                                       class="custom-contextmenu">
                            <ng-template let-item pTemplate="item">
                                <a class="flex align-items-center p-menuitem-link custom-menu-item" pRipple>
                                    <i [class]="item.icon + ' menu-item-icon'"></i>
                                    <span class="ml-2 menu-item-text">{{ item.label }}</span>
                                </a>
                            </ng-template>
                        </p-contextMenu>
                    </td>
                </tr>
                @if (isExpanded(account) && expandedRowTemplate) {
                    <tr class="expanded-row">
                        <ng-container *ngTemplateOutlet="expandedRowTemplate; context: {$implicit: account}"></ng-container>
                    </tr>
                }
            } @empty {
                <tr>
                    <td class="text-center" colspan="10">{{ emptyText }}</td>
                </tr>
            }
        }
    </tbody>
</table>
